// extracted by mini-css-extract-plugin
export default {"createForm":"CustomerSubscriptionsModule_createForm__dLGKz","subscriptions":"CustomerSubscriptionsModule_subscriptions__GK3fa"};